import { render, staticRenderFns } from "./TToolTip.vue?vue&type=template&id=bdc21142&scoped=true&"
import script from "./TToolTip.vue?vue&type=script&lang=js&"
export * from "./TToolTip.vue?vue&type=script&lang=js&"
import style0 from "./TToolTip.vue?vue&type=style&index=0&id=bdc21142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc21142",
  null
  
)

export default component.exports